const state = {
  currentBrand: {},
};

const mutations = {
  setCurrentBrand(state, obj) {
    state.currentBrand = obj;
  },
};

const actions = {
  // 事件
  selectBrand({ commit, rootState }, brand) {
    const { brandList } = rootState.config;
    const index = brandList.findIndex((item) => item.brand_id == brand.pcauto_id);
    commit('setCurrentBrand', brandList[index]);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
